import { defineComponent as _defineComponent } from 'vue'
import {ref, onMounted, Ref, computed} from 'vue'
import QueryParams, {Configuration} from "@/app/helpers/QueryParams";
import {useRoute} from "vue-router/composables";
import kebabCase from "lodash/kebabCase";
import ProgressBar from "@/components/ProgressBar.vue"
import Edition from "@/app/models/Edition";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css"
import ImageCarousel from "@/components/ImageCarousel.vue";
import CarInformation from "@/components/edition/CarInformation.vue";
import EditionOptionContainer from "@/components/edition/EditionOptionContainer.vue";
import StaticEditionOption from "@/components/edition/StaticEditionOption.vue";
import ContractConfiguration from "@/components/edition/ContractConfiguration.vue";
import CarTradeInConfiguration from "@/components/edition/CarTradeInConfiguration.vue";
import ColorEditionOption from "@/components/edition/ColorEditionOption.vue";
import CheckboxEditionOption from "@/components/edition/CheckboxEditionOption.vue";
import OwnRiskEditionOption from "@/components/edition/OwnRiskEditionOption.vue";
import SummaryCard from "@/components/sidebar/SummaryCard.vue";
import SideBar from "@/components/sidebar/SideBar.vue";
import ConversionButtonsCard from "@/components/sidebar/ConversionButtonsCard.vue";
import PriceConditionCard from "@/components/sidebar/PriceConditionCard.vue";
import ShareButtonsCard from "@/components/sidebar/ShareButtonsCard.vue";
import ReachabilityCard from "@/components/sidebar/ReachabilityCard.vue";
import StickyBar from "@/components/StickyBar.vue"
import RationalImage from "@/components/RationalImage.vue"
import store from "@/store"
import CallToActionButton from "@/components/CallToActionButton.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Edition',
  setup(__props) {

const route = useRoute()

const configuration: Ref<Configuration | null> = ref(null)
const edition: Ref<Edition | null> = ref(null)

const backUrlParameters = computed(() => {
  return {
    name: "car.editions",
    params: {
      carName: kebabCase(edition.value?.carName),
      id: edition.value?.carId,
    },
    query: {
      mileage: configuration.value?.mileage ? configuration.value.mileage : undefined,
      duration: configuration.value?.duration ? configuration.value.duration : undefined
    }
  }
})
const isPrivateLease = computed(() => store.state.settings.leaseForm === 1)

onMounted(async () => {
  configuration.value = await QueryParams.parse(route.query, route.params.editionId)
  edition.value = configuration.value?.edition
})


return { __sfc: true,route, configuration, edition, backUrlParameters, isPrivateLease, QueryParams, kebabCase, ProgressBar, ImageCarousel, CarInformation, EditionOptionContainer, StaticEditionOption, ContractConfiguration, CarTradeInConfiguration, ColorEditionOption, CheckboxEditionOption, OwnRiskEditionOption, SummaryCard, SideBar, ConversionButtonsCard, PriceConditionCard, ShareButtonsCard, ReachabilityCard, StickyBar, RationalImage, CallToActionButton }
}

})